import { fetchJson } from '@frontend/store/fetch';

export async function loadOrganization(orgId: string) {
    const result = await fetchJson(`/api/organizations/${orgId}`, 'GET');

    return result.json;
}
